<template>
  <div class="latest-preview">
    <preview v-bind="previewData" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Preview from '@/components/Preview.vue';

export default {
  name: 'LatestPreview',
  components: {
    Preview,
  },
  computed: {
    ...mapGetters([
      'getStrip',
      'getLatestStripNumber',
    ]),
    strip() {
      return this.getStrip(this.getLatestStripNumber);
    },
    previewData() {
      return {
        src: this.strip.urlThumb,
        title: 'Latest Strip',
        description: `${this.strip.number}: ${this.strip.name}`,
        link: {
          name: 'Comic',
          params: {
            stripNumber: this.getLatestStripNumber,
          },
        },
      };
    },
  },
};
</script>
